export const imageSmallSize = `/image/thumbnail`;
